export const DownRightCurvedArrowSVG = () => {
  return (
    <svg
      width="28"
      height="25"
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2929 24.7074C19.6834 25.0979 20.3166 25.0979 20.7071 24.7074L27.0711 18.3434C27.4616 17.9529 27.4616 17.3198 27.0711 16.9292C26.6805 16.5387 26.0474 16.5387 25.6569 16.9292L20 22.5861L14.3431 16.9292C13.9526 16.5387 13.3195 16.5387 12.9289 16.9292C12.5384 17.3198 12.5384 17.9529 12.9289 18.3434L19.2929 24.7074ZM5.53528e-05 2.72021C3.02494 2.72005 7.73273 2.7405 11.7019 5.34152C15.5832 7.88496 19 13.0786 19 24.0003H21C21 12.6419 17.4168 6.69538 12.7981 3.6687C8.26727 0.699613 2.97506 0.72005 -5.53528e-05 0.720215L5.53528e-05 2.72021Z"
        fill="#B9B9B9"
      />
    </svg>
  );
};
